import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import useEditorControl from "../../custom_hooks/complex/useEditorControl";
import UiContext from "../../store/ui-context";
import configs from "./ProfileEditorConfigs";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";

const title = "Profil Saya";

const editorConfigs = configs;
const apiName = "masterdata/karyawan";
let apiSuffix;
const customElements = [];
const isForm = false;

const ProfileEditorDialog = (props) => {
  const uiContext = useContext(UiContext);
  const user = useSelector((state) => state.auth.user);
  
  const { requestPost } = useAPIRequest();

  const {
    // methods
    onSave,
    onFetchData,
    handleInputChange,
    handleMultipleInputChange,
    // states
    value,
    setValue,
    setError,
    loading,
    elements,
    //utils
    validator,
  } = useEditorControl({
    configs,
    isForm,
    apiName,
    apiSuffix,
    customElements,
  });

  const fetchData = async () => {
    const body = [];
    await requestPost({
      fullUrl: "/api/me",
      body,
      isForm: false,
      onSuccess: ({ data, message }) => {
        setValue(data);
      },
      onError: ({ data, message }) => {
        console.log(data);
      }
    });
  };

  useEffect(() => {
    if (props.visible) {
      fetchData();
    }
  }, [props.visible]);

  const convertValue = () => {
    var newValue = {
      ...value,
      // data_positions: [],
    };
    delete newValue.id;

    if (newValue.password !== "") {
      newValue.password = newValue.password;
      newValue.cpassword = newValue.cpassword;
    }

    return newValue;
  };

  const validation = () => {
    return validator({
      configs: configs,
      value: value,
      onError: (error) => setError(error),
      isEmpty: "nip",
      mustEqual: ["password cpassword"],
    });
  };

  const handleOnSave = async (event) => {
    event.preventDefault();
    const valid = validation();
    if (valid) {
      const body = convertValue();
      console.log(body);
      
      requestPost({
        fullUrl: "/api/user/editprofile",
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data, message }) => {
          uiContext.showSuccessMsg("Success", message);
        },
      });
    }
  };

  const dialogFooter = (
    <React.Fragment>
      <div className="row-end-end">
        <Button
          label="Cancel"
          icon="pi pi-times"
          outlined
          onClick={props.onHide}
        />
        <Button
          label="Simpan"
          icon="pi pi-save"
          loading={loading}
          onClick={(e) => {
            handleOnSave(e);
          }}
        />
      </div>
    </React.Fragment>
  );

  return (
    <Dialog
      visible={props.visible}
      style={{ width: "45rem" }}
      header={title}
      modal
      footer={dialogFooter}
      onHide={props.onHide}
    >
      <div className="col-start-center relative h-100">
        <div className="col-start-start w-100 gap-3">
          <div className={`row-start-start w-100`}>
            <div className="col-start-start w-100 gap-3">
              {elements.username}
              {elements.password}
              {elements.cpassword}
            </div>
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ProfileEditorDialog;
